<div class="tenant-profile-wrapper">
    <div class="tenant-profile-inner-wrapper" >
        <div>
            <h1 class="tenant-greeting"> WELCOME BACK, <span style="text-transform: uppercase;"> {{ tenantName }}! </span> </h1>
            <div style="display: flex; ">
                <fa-icon [icon]="faHome" class="fa-2x" style="margin-right: 10px;"></fa-icon>
                <h3 class="tenant-address"> {{ tenantDetails[0].property.flat_no }}, {{ tenantDetails[0].property.name }}, {{ tenantDetails[0].property.addressl1 }} </h3>
            </div>        
        </div>
        <div>
            <img src="assets/images/profile.png" style="width: 100px; height: 100px;" alt="YourOwnROOM Tenant Profile Picture">
        </div>
    </div>
    <div class="edit-profile-btn-wrapper" >
        <div class="edit-profile-btn-inner-wrapper" (click)="openEditProfile()"> 
            <fa-icon [icon]="faEdit" class="fa-2x" style="font-size: 16px; margin-right: 10px;"></fa-icon>
            <p style="margin: 0;"> Edit Profile </p>
        </div>
    </div>    
</div>

<!-- Blocks -->
<div class="section">
    <div class="row">        
        <div class="col-md-6 col-lg-3 dashboard-blocks-wrapper">
            <div class="dashboard-blocks exit-container">
                <div class="icon-text-container" >
                    <div class="icon-wrapper agreement-wrapper" >
                        <fa-icon [icon]="faFileContract" class="fa-2x block-icons exit-icon" > </fa-icon>
                    </div>
                    <div>
                        <p class="dashboard-block-title" > Agreement Exp. </p>
                        <p class="dashboard-block-details"> {{ tenantDetails[0].occupto  }} </p>
                    </div>
                </div>
                <div class="dashboard-block-button-wrapper agreement-wrapper agreement-renew-wrapper" >
                    <p class="dashboard-block-button agreement-block-button button-renewal" data-toggle="modal" data-target="#tenantRenewalModal"> Renew <br> Contract </p>
                    <p class="dashboard-block-button agreement-block-button exit-button" data-toggle="modal" data-target="#tenantExitModal" > End <br> Contract </p>
                    
                </div>
            </div>
        </div>
        <div class="col-md-6 col-lg-3 dashboard-blocks-wrapper">
            <div class="dashboard-blocks rental-container">
                <div class="icon-text-container" >
                    <div class="icon-wrapper rent-receipt-wrapper" >
                        <fa-icon [icon]="faMoneyCheckAlt" class="fa-2x block-icons rental-icon"  > </fa-icon>
                    </div>
                    <div>
                        <p class="dashboard-block-title" > Monthly Rent </p>
                        <p class="dashboard-block-details"> &#x20B9; {{ tenantDetails[0].rent }} </p>
                    </div>
                </div>
                <div class="dashboard-block-button-wrapper rent-receipt-wrapper" (click)="fetchPaymentSchedules()" >
                    <p class="dashboard-block-button rent-button" data-toggle="modal" data-target="#tenantRentModal" > View <br> Rent Receipts </p>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-lg-3 dashboard-blocks-wrapper">
            <div class="dashboard-blocks desposit-container">
                <div class="icon-text-container " >
                    <div class="icon-wrapper deposit-wrapper" >
                        <fa-icon [icon]="faRupeeSign" class="fa-2x block-icons deposit-icon"  > </fa-icon>
                    </div>
                    <div >
                        <p class="dashboard-block-title" > Deposit </p>
                        <p class="dashboard-block-details" *ngIf=" tenantDetails[0].deposite > 0 && tenantDetails[0].pendingdeposite == 0 ">
                             &#x20B9; {{ tenantDetails[0].deposite }} </p>
                    </div>                    
                </div>
                <div class="dashboard-block-button-wrapper deposit-wrapper" >
                    <p class="dashboard-block-button deposit-button"> <span> Paid <br> Security Deposit  </span> 
                         <!-- {{ tenantDetails[0].deposite > 0 && tenantDetails[0].pendingdeposite == 0 ? : 
                        tenantDetails[0].deposite > 0 && tenantDetails[0].pendingdeposite > 0 ? "Partially Paid" : "Unpaid" }}  -->
                    </p>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-lg-3 dashboard-blocks-wrapper">
            <div class="dashboard-blocks outstanding-container">
                <div class="icon-text-container" >
                    <div class="icon-wrapper" >
                        <fa-icon [icon]="faMoneyCheck" class="fa-2x block-icons"  > </fa-icon>
                    </div>
                    <div>
                        <p class="dashboard-block-title" > Total Outstanding </p>
                        <p class="dashboard-block-details"> ₹ {{ outstandingAmount ? outstandingAmount : '0'  }} </p>
                    </div>
                </div>
                <div class="dashboard-block-button-wrapper" data-toggle="modal" data-target="#outstandingPaymentModal" (click)="payOutstandingAmt('rent', tenantDetails[0].id)">
                    <p class="dashboard-block-button"> Clear <br> Outstanding Dues </p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Service Requests and Audits block -->
<div class="section">
    <div class="row">
        <div class="col-md-6 col-lg-6">
            <div class="dashboard-block-services-audits service-block">
                <div class="service-block-title-wrapper">
                    <p class="service-block-title"> Active Service Requests</p>
                    <p class="raise-request-btn" data-toggle="modal" data-target="#tenantServiceModal"> Raise Request </p>
                </div>
                <div class="service-request-details-wrapper"  *ngFor="let asr of activeServiceList">
                    <div class="service-request-sub-details-wrapper">
                        <p class="service-request-details service-request-id"> #YOR_{{asr.id}} </p>
                        <p class="service-request-details service-request-type"> 
                            {{asr.type == 1 ? "Keys" : asr.type == 12 ?"Plumbing" : asr.type == 17 ?"Furniture" : asr.type == 47 ?"Cleaning" : 
                                    asr.type == 49 ?"Electrical" : asr.type == 51 ?"Carpentry" : asr.type == 60 ?"Others" : " "}} 
                        </p>
                        <p class="service-request-details service-request-date"> {{ asr.created_at  }} </p>
                    </div>
                    <div class="service-request-status-wrapper" >
                        <div class="service-request-status-inner-wrapper" [ngStyle]=
                        "asr.status == 1 ? {'background-color' : '#F7DFC9' , 'color': '#FF6B00'} :                       
                            {'background-color' : '#C9EEF7' , 'color': '#00A6FF'}" >
                            <p class="service-request-status" > {{ asr.status == 1 ? "Open" : "In-Progress" }} </p>
                        </div>                        
                    </div>
                </div>  
                <div *ngIf="activeServiceList.length == 0" style="height: 100%;">
                    <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                        <p class="no-active-services"> No Active services </p>
                    </div>                    
                </div>              
            </div>
        </div>
        <div class="col-md-6 col-lg-6 upcoming-audit-block-wrapper">
            <div class="dashboard-block-services-audits audit-block">
                <p class="service-block-title audit-title"> Upcoming Audit </p>
                <p class="dashboard-audit-details"> An audit is scheduled for your property on 20 July 22. Please contact our team if you’re not available. </p>
                <div class="dashboard-audit-contact-wrapper">
                    <p class="dashboard-audit-contact contact-phone"> + 91 91486 33679 </p>
                    <p class="dashboard-audit-contact contact-email"> care@yourownroom.com </p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Agreement Section  -->
<div class="section">
    <div class="agreement-section-wrapper">             
        <div class="section-title-wrapper">
            <p class="section-title"> Agreement Details </p>
            <p class="view-rental-agreement"  >  
                <span (click)="viewRentalAgreement()"> View rental agreement </span>
                <span style="color: black; margin-left: 20px; cursor: pointer;" data-toggle="collapse" href="#agreementCollapse" role="button" aria-expanded="false"> 
                    <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
                </span>  
            </p>
        </div>
        <div class="collapse" id="agreementCollapse">
            <div class="agreement-date-wrapper flex-line-display">
                <p class="agreement-date-text"> Agreement Start Date: </p>
                <p class="agreement-date-text"> {{ tenantDetails[0].occupfrom }} </p>
            </div>
            <div class="agreement-date-wrapper flex-line-display agreement-end-date">
                <p class="agreement-date-text"> Agreement End Date: </p>
                <p class="agreement-date-text"> {{ tenantDetails[0].occupto }} </p>
            </div>
            
            <!-- If the agreement ends within 1 month -->
            <div class="agreement-ending-message-wrapper"  *ngIf="remainingAgreementDays < 30">
                <p class="agreement-end-message">  Your Agreement is ending in 30 days. Please take the neccessary actions for your stay. </p>
            </div>
            <div class="agreement-exit-wrapper">
                <p class="agreement-exit-button"> Raise Exit  </p>
            </div>
        </div>
    </div>
</div>

<!-- Documents Section  -->
<div class="section">
    <div class="document-section-wrapper">
        <div class="section-title-wrapper">
            <p class="section-title document-section"> Documents </p>            
            <span style="color: black; margin-left: 20px; cursor: pointer;" data-toggle="collapse" href="#documentCollapse" role="button" aria-expanded="false"> 
                <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
            </span>              
        </div>
        <div class="collapse" id="documentCollapse" style="margin-top: 20px;">            
            <div class="row document-row-item">
                <div class="col-md-6 col-lg-4 col-sm-12" *ngFor="let docs of getDocuments">                    
                    <div class="document-card">
                        <div class="document-card-type-title">
                            <p class="document-type">
                                {{ docs.type == 'adhar' ? "aadhaar" : docs.type == 'rent' ? "rental agreement" : docs.type == 'pan' ? "PAN" : 
                                docs.type == 'voterid' ? "Voter Id" : docs.type == 'driving_license' ? "Driving License" : 'Not Found' }} 
                            </p>
                        </div>
                        <div class="document-detail-wrapper">
                            <div class="card-detail-list-wrapper document-detail-list-wrapper">
                                <p class="card-detail-list"> Document No:  </p>
                                <p class="card-detail-list document-list-value"> {{ docs.docNo }} </p>
                            </div>
                            <div class="card-detail-list-wrapper document-detail-list-wrapper">
                                <p class="card-detail-list"> Uploaded on:  </p>
                                <p class="card-detail-list document-list-value"> {{ docs.created_at }} </p>
                            </div>

                            <div class="document-link-margin">
                                <div class="card-detail-list-wrapper document-detail-list-wrapper">
                                    <p class="card-detail-list document-link" (click)="openDocs(docs.url)"> View Document </p>
                                    <p class="card-detail-list" [ngStyle]="{'color' : docs.status == 0 ? '#F9E316' : docs.status == 1 ? '#FF0000' : '#77D353'}">                                        
                                        {{ docs.status == 0 ? "Pending" : docs.status == 10 ? "Verified" : "Rejected" }}
                                        <fa-icon [icon]="docs.status == 0 ? faClock  : docs.status == 1 ? faTimesCircle : faCheckCircle "> </fa-icon>                                         
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>                    
                </div>
                              
            </div>
        </div>
    </div>
</div>

<div class="section">
    <div class="services-section-wrapper">
        <div class="section-title-wrapper">
            <p class="section-title service-section-title" > Service Request </p>            
            <span style="color: black; margin-left: 20px; cursor: pointer;" (click)="getServiceList()" data-toggle="collapse" href="#servicesCollapse" role="button" aria-expanded="false"> 
                <fa-icon [icon]="faChevronDown" class="fa-sm" ></fa-icon>  
            </span>              
        </div>
        
        <div class="collapse" id="servicesCollapse">
            <div class="row service-row-item">
                <div class="col-md-6 col-lg-4 col-sm-12" *ngFor="let reqs of tenantServiceList">                    
                    <div class="service-card" [ngStyle]=
                    "reqs == 1 ?   {'border' : '3px solid rgb(246, 104, 104)'} : reqs == 12 ? {'border' : '3px solid rgb(54, 162, 235)' } 
                    : reqs == 17 ? {'border' : '3px solid rgb(75, 192, 192)' } : reqs == 47 ? {'border' : '3px solid rgb(255, 205, 86)' }  
                    : reqs == 49 ? {'border' : '3px solid rgb(153, 102, 255)'} : reqs == 51 ? {'border' : '3px solid rgb(193, 154, 107)'}
                    : {'border' : '3px solid rgb(231,233,237)' }" >
                        <div class="service-card-type-title-wrapper">                            
                            <p class="service-request-type"> 
                                {{reqs == 1 ? "Keys" : reqs == 12 ?"Plumbing" : reqs == 17 ?"Furniture" : reqs == 47 ?"Cleaning" : 
                                    reqs == 49 ?"Electrical" : reqs == 51 ?"Carpentry" : reqs == 60 ?"Others" : " "}} 
                            </p>                                
                            <img class="service-icons" 
                                src="{{ reqs == 1 ? 'assets/images/tenantDashboard/keys.png' : reqs == 12 ? 'assets/images/tenantDashboard/plumbing.png' 
                                : reqs == 17 ? 'assets/images/tenantDashboard/furniture.png' : reqs == 47 ? 'assets/images/tenantDashboard/cleaning.png' 
                                : reqs == 49 ? 'assets/images/tenantDashboard/electrical.png' : reqs == 51 ? 'assets/images/tenantDashboard/carpentry.png'
                                : 'assets/images/tenantDashboard/other-services.png' }}" />                            
                        </div>
                        <div>
                            <div class="card-detail-list-wrapper">
                                <p class="card-detail-list"> Total Requests:  </p>
                                <p class="card-detail-list document-list-value"> 
                                    {{reqs == 1 ? totalKeyServices : reqs == 12 ?totalPlumbingServices : 
                                    reqs == 17 ?totalFurnishingServices : reqs == 47 ?totalCleaningServices : 
                                    reqs == 49 ?totalElectricalServices : reqs == 51 ?totalCarpentryServices : 
                                    reqs == 60 ?totalOtherServices : " "}}
                                </p>
                            </div>
                            <div class="card-detail-list-wrapper">
                                <p class="card-detail-list"> Total Amount Paid:  </p>
                                <p class="card-detail-list document-list-value"> &#x20B9; 100   </p>
                            </div>                            
                            <p class="view-request-btn" (click)="serviceRequestDetail(reqs)" data-toggle="modal" data-target="#viewServiceRequest"> View Requests </p>                                                        
                        </div>
                    </div>                    
                </div>
                              
            </div>
            <div *ngIf="tenantServiceList.length == 0" style="height: 60px;">
                <div >
                    <p style="font-size: 18px;
                    text-align: center;
                    margin-top: 30px;"> No Services Raised yet</p>
                </div>
            </div>
        </div>
    </div>
</div>



<!-- All Modals here -->
<div class="modal fade" id="tenantRentModal" tabindex="-1" aria-labelledby="tenantRentModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header" style="padding: 0;">
                <div class="modal-body" style="padding: 0;">                    
                    <div class="col-md-12">
                        <div class="modal-close-button-wrapper">
                            <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" style="cursor: pointer;" ></fa-icon>
                        </div>                        
                    </div>
                    <div>
                        <div class="scroll" *ngIf="rentReceipts.length > 0">
                            <div class="row" style="padding: 10px;"> 
                                <div class="col-md-6 col-lg-6" *ngFor="let rec of rentReceipts">
                                    <div class="rent-receipt-card " >
                                        <div class="rent-receipt-details">
                                            <p> {{ rec.dispMonth }} </p>
                                            <p> Status: <fa-icon [icon]="faCheckCircle" class="fa-sm" style="color: #339af0;" > </fa-icon>  </p>
                                        </div>
                                        <div class="rent-receipt-details">
                                            <p style="font-weight: 500;">  &#x20B9; {{ rec.amount }}  </p>
                                            <p *ngIf="rec.status==2" >                                                
                                                <a  style="text-decoration: none !important;" 
                                                    href="{{ ('https://api.yourownroom.com/api/w/v1/user/receipt/' + rec.id + '/' + user.id + '/1')  }}">
                                                    <span style="color: #339af0">
                                                        <fa-icon [icon]="faFileDownload"></fa-icon>
                                                    </span>
                                                Download 
                                                </a> 
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="rentReceipts.length == 0">
                            <div style="padding: 40px 0px; text-align: center;">
                                <h1> No Rent Receipts to show!</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Raise Exit Request Modal  -->
<div class="modal fade" id="tenantExitModal" tabindex="-1" aria-labelledby="tenantExitModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header" style="padding: 0;">
                <div class="modal-body" style="padding: 0;">                    
                    <div class="col-md-12">
                        <div class="modal-close-button-wrapper">
                            <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" style="cursor: pointer;" ></fa-icon>
                        </div>                        
                    </div>
                    <div>
                        <h3 class="exit-form-title"><fa-icon [icon]="faSadTear" class="fa-sm"> </fa-icon>  We're sorry to see you go! </h3>
                        <form role="form">
                            <div class="form-group col-md-12">
                                <input class="col-md-12 form-control"  [min]="minExitDate" name="exitdate" 
                                [ngModel]="userexit.exitdate" (ngModelChange)="changeExitDate($event)" type="text" onfocus="(this.type='date')" id="date" >
                            </div>
                            <div class="form-group col-md-12">
                                <textarea name="exitreason" class="form-control col-md-12 mt-2 mb-2" rows="5" placeholder="Reasons for Exit" 
                                [ngModel]="userexit.reason" (ngModelChange)="changeExitReason($event)" required></textarea>
                            </div>
                            <div class="form-group col-md-12 tenant-btn-wrapper">
                                <p class="tenant-btn exit-form-button" (click)="initiateExitProcess(tenantDetails[0].id,tenantDetails[0].property_id)" data-dismiss="modal" >Submit</p>    
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Renewal Modal -->
<div class="modal fade" id="tenantRenewalModal" tabindex="-1" aria-labelledby="tenantRenewalModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header" style="padding: 0;">
                <div class="modal-body" style="padding: 0;">                    
                    <div class="col-md-12">
                        <div class="modal-close-button-wrapper">
                            <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" style="cursor: pointer;" ></fa-icon>
                        </div>                        
                    </div>
                    <div style="padding: 20px;">
                        <div>
                            <p style="font-size: 18px; font-weight: 500; text-align: center;"> Do you want to renew your rental agreement ? If 'Yes', click on Submit. </p>
                        </div>
                        <div style="display: flex; justify-content: center;">
                            <div style="max-width: 250px; display: flex;  justify-content: space-between; align-items: center;margin-top: 30px;">
                                <p class="renewal-modal-button renewal-submit" (click)="initiateAgreementRenewal()" data-dismiss="modal" > Submit </p>
                                <p class="renewal-modal-button renewal-cancel" data-dismiss="modal"> Cancel </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Raise Service Request -->
<div class="modal fade" id="tenantServiceModal" tabindex="-1" aria-labelledby="tenantServiceModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header" style="padding: 0;">
                <div class="modal-body" style="padding: 0;">                    
                    <div class="col-md-12">
                        <div class="modal-close-button-wrapper">
                            <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" style="cursor: pointer;" ></fa-icon>
                        </div>                        
                    </div>
                    <div>
                        <h3 class="exit-form-title"><fa-icon [icon]="faTools" class="fa-sm"> </fa-icon>  How may we help you? </h3>
                        <form role="form">
                            <div class="form-group col-md-12 col-sm-12">
                                <select name="serType" [ngModel]="serviceRequest.type" (ngModelChange)="onServiceTypeChange($event)" class="form-control p-2" style="width: 100%">
                                    <option value="0" disabled> Type </option>
                                    <option *ngFor="let x of serviceRequestTypes" [ngValue]="x.id">{{x.text}} </option>
                                </select>                                       
                            </div>
                            <div class="form-group col-md-12 col-sm-12">
                                <textarea class="form-control col-md-12" (change)="onServiceDescriptionChange($event)" placeholder="Description"></textarea>
                            </div>
                            <div class="form-group col-md-12 col-sm-12">
                                <input type="file" id="imageupload" class="form-control upload_box" name="images" >
                            </div>
                            <div class="form-group col-md-12 tenant-btn-wrapper">
                                <p class="tenant-btn exit-form-button" (click)="raiseNewServiceRequest(tenantDetails[0].property_id,tenantDetails[0].room_id)" data-dismiss="modal" >Submit</p>    
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Rent Payment Modal -->
<div class="modal fade" id="outstandingPaymentModal" tabindex="-1" aria-labelledby="outstandingPaymentModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header" style="padding: 0;">
                <div class="modal-body" style="padding: 0;">                    
                    <div class="col-md-12">
                        <div class="modal-close-button-wrapper">
                            <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" style="cursor: pointer;" ></fa-icon>
                        </div>                        
                    </div>
                    <div *ngIf="outstandingAmount > 0 ">                        
                        <div class="col-md-12">
                            <h3 class="text-center">  Total amount due is :  
                                <span style="font-weight: 600;"><em>&nbsp; &#x20B9;  {{ outstandingAmount }}</em> </span> 
                            </h3>
                            <hr/>
                            <div class="text-center">
                                <p>Scan & Pay through UPI (Zero Convenience Fee)</p>                                
                                <ngx-qrcode 
                                    [elementType]="url" 
                                    [value] = "qrcodeval"
                                    errorCorrectionLevel = "L">
                                </ngx-qrcode>
                            </div>
                            <div class="text-left rent-payment-modal-wrapper">
                                <div>
                                    <h4 class="text-center"> Your Virtual Account Number for NEFT / IMPS / Bank Transfer : <span style="font-weight: 600;"><em>{{ tenantDetails[0].virtual_number }} </em></span> </h4>
                                    <h4 style="text-align: left;"> IFSC : <span style="font-weight: 500;"> <em>DBSS0IN0811</em> </span> </h4>
                                    
                                    <div class="payment-gateway-wrapper">
                                        <p class="d-flex align-items-center" style="font-size: 10px;padding: 5px 10px 5px 0px;">
                                            <input class="paym_gateway gateway_select" name="rent_pay" type="radio" value="razor" [ngModel]="rent_payment" (change)="changegateway($event)">&nbsp;
                                            <img src="https://razorpay.com/images/logo.png" class="payment-gateway-logo" >
                                        </p>
                                        <p style="font-size: 12px; text-align: left; font-weight: 400;"> Convenience fee of 1.75% + 18%GST Applicable </p>
                                        
                                    </div>
                                </div>
                            </div>
                            <div class="pay-button-wrapper">
                                <p class="pay-button" [disabled]="!paymentButton ? 'disabled' : null" (click)="initPayment()">Pay Now</p>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="outstandingAmount == 0">
                        <h2> No Outstanding dues </h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- View Service Requests -->

<div class="modal fade" id="viewServiceRequest" tabindex="-1" aria-labelledby="viewServiceRequestLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <div class="modal-body">
                    <div style="display: flex; justify-content: end; position: absolute; top:-10px; right: -5px; cursor: pointer;">
                        <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
                    </div>
                    <div style="display: flex; justify-content: space-between;">
                        <h2 class="modal-title"> {{serviceRequestTypeId == 1 ? "Keys" : serviceRequestTypeId == 12 ?"Plumbing" : serviceRequestTypeId == 17 ?"Furniture" : serviceRequestTypeId == 47 ?"Cleaning" : serviceRequestTypeId == 49 ?"Electrical" : serviceRequestTypeId == 51 ?"Carpentry" : serviceRequestTypeId == 60 ?"Others" : " "}}  </h2>
                        <img class="service-icons" 
                                src="{{ serviceRequestTypeId == 1 ? 'assets/images/tenantDashboard/keys.png' : serviceRequestTypeId == 12 ? 'assets/images/tenantDashboard/plumbing.png' 
                                : serviceRequestTypeId == 17 ? 'assets/images/tenantDashboard/furniture.png' : serviceRequestTypeId == 47 ? 'assets/images/tenantDashboard/cleaning.png' 
                                : serviceRequestTypeId == 49 ? 'assets/images/tenantDashboard/electricial.png' : serviceRequestTypeId == 51 ? 'assets/images/tenantDashboard/carpentry.png'
                                : 'assets/images/tenantDashboard/other-services.png' }}" />                            
                    </div>
                    <div *ngFor="let sr of individualServices" class="individual-requests" 
                            [ngStyle]=
                                "sr.status == 1 ? {'background-color' : '#FEF7EA' , 'border': '1px solid #F9E316'} : 
                                sr.status == 2 ? {'background-color' : '#E5EFFA' , 'border': '1px solid #339af0'} :  
                                {'background-color' : '#EBF7EE' , 'border': '1px solid #4BB543'}">
                        <div class="d-flex justify-content-between">
                            <p style="font-weight: 600; ">                                    
                                #YOR_{{sr.id}}
                            </p>
                            <p style="text-align: left; font-weight: 600; text-transform: uppercase;" >    
                                {{sr.status == 1 ? 'Open' : sr.status == 2 ? 'In-Progress' : 'Closed'}} 
                            </p>
                        </div>
                        <div class="individual-service-request-details">
                            <p>{{sr.detail }}</p>
                        </div>                            
                        <div class="row justify-content-between">
                            <div class="col-12 col-md-4">
                                <p>Raised on: <span style="font-weight: 500;">{{sr.created_at}}</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Custom Notification  -->
<div *ngIf="alertOpen == true"  class="message-on-submit-wrapper">  
    <div class="message-on-submit">  
        <div class="alert alert-primary" role="alert">          
            <p class="alert-custom-message" > {{ submitMessage }} </p>
        </div>
    </div>  
</div>